<template>
    <div class="page-content">
        <div class="page-tool-bar">
            <div class="el-btn-group">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="addDepartment">新增</el-button>
                <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    :disabled="multipleSelection.length <= 0"
                    @click="deleteDepartment(null)"
                    >删除</el-button
                >
            </div>

            <div class="icon-group">
                <span title="搜索" class="icon-box" @click="search">
                    <Icon color="#606266">
                        <Search />
                    </Icon>
                </span>
                <span class="icon-box" @click="refreshDepartmentList">
                    <Icon color="#606266">
                        <Refresh />
                    </Icon>
                </span>
            </div>
        </div>
        <el-table
            :data="departmentList"
            default-expand-all
            row-key="id"
            size="small"
            height="100%"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            @selection-change="handleSelectionChange"
        >
            <el-table-column align="center" type="selection" min-width="8%"> </el-table-column>
            <el-table-column align="left" prop="deptName" label="部门名称" min-width="30%"> </el-table-column>
            <el-table-column align="center" prop="grade" label="机构等级" min-width="12%">
                <template slot-scope="scop">
                    <span v-if="scop.row.grade == 1">一级</span>
                    <span v-if="scop.row.grade == 2">二级</span>
                    <span v-if="scop.row.grade == 3">三级</span>
                    <span v-if="scop.row.grade == 4">四级</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="sort" label="排序" min-width="10%"> </el-table-column>
            <el-table-column align="center" label="是否可用" min-width="12%">
                <template slot-scope="scop">
                    <el-tag type="success" size="normal" effect="light" v-if="scop.row.status == 1">正常</el-tag>
                    <el-tag type="danger" size="normal" effect="light" v-if="scop.row.status == 0">禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="40%">
                <template slot-scope="scop">
                    <div class="operation">
                        <div @click="checkDepartment(scop.row.id)">
                            <Icon size="16">
                                <Eye24Regular />
                            </Icon>
                            <span class="operation-label">查看</span>
                        </div>
                        <div @click="editDepartment(scop.row.id)">
                            <Icon size="16">
                                <Edit24Regular />
                            </Icon>
                            <span class="operation-label">修改</span>
                        </div>
                        <div @click="deleteDepartment(scop.row.id)">
                            <Icon size="16" style="color: red">
                                <Delete24Regular />
                            </Icon>
                            <span class="operation-label" style="color: red">删除</span>
                        </div>
                        <div @click="addChildDepartment(scop.row.id)">
                            <Icon size="16">
                                <AddCircle24Regular />
                            </Icon>
                            <span class="operation-label">添加下级部门</span>
                        </div>
                        <div>
                            <Icon size="16">
                                <Person24Filled />
                            </Icon>
                            <span class="operation-label" @click="DeptUser(scop.row)">分配用户</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 新增/查看/修改用户信息 -->
        <el-dialog :title="departmentStates[departmentState]" :visible.sync="showDialog" width="400px" @close="closeDialog">
            <div>
                <el-form :model="department" :rules="dataRule" ref="department" label-width="80px" :inline="true" size="mini">
                    <el-form-item label="上级部门" prop="parentId">
                        <el-select
                            style="width: 200px"
                            v-model="department.parentId"
                            placeholder="请选择部门名称"
                            :disabled="departmentState == 'check'"
                            clearable
                            size="small"
                        >
                            <el-tree default-expand-all :data="departmentList" :props="treeProps">
                                <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                    <el-option :label="node.label" :value="data.id"> </el-option>
                                </div>
                            </el-tree>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="部门名称" prop="deptName">
                        <el-input
                            v-model="department.deptName"
                            size="small"
                            style="width: 200px"
                            :disabled="departmentState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="部门等级" prop="grade">
                        <el-select
                            style="width: 200px"
                            size="small"
                            v-model="department.grade"
                            placeholder="请选择"
                            :disabled="departmentState == 'check'"
                        >
                            <el-option label="一级" :value="1"> </el-option>
                            <el-option label="二级" :value="2"> </el-option>
                            <el-option label="三级" :value="3"> </el-option>
                            <el-option label="四级" :value="4"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="是否可用" prop="status">
                        <el-select
                            style="width: 200px"
                            size="small"
                            v-model="department.status"
                            placeholder="请选择"
                            :disabled="departmentState == 'check'"
                        >
                            <el-option label="正常" :value="1"> </el-option>
                            <el-option label="禁用" :value="0"> </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="排序" prop="sort">
                        <el-input-number
                            style="width: 200px"
                            :disabled="departmentState == 'check'"
                            v-model="department.sort"
                            size="small"
                            label=""
                            :min="1"
                            :max="100"
                            :step="1"
                            :controls="true"
                            controls-position="both"
                        >
                        </el-input-number>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="flex justify-end">
                <el-button @click="closeDialog">关闭</el-button>
                <el-button type="primary" @click="submitForm" v-if="departmentState != 'check'">确定</el-button>
            </div>
        </el-dialog>

        <!--  -->
        <DeptUser ref="deptUser" :dept="currentDept" />
    </div>
</template>

<script>
import DeptUser from '@/components/organization/DeptUser.vue';
import { GridDots, ArrowDown, Refresh, Printer, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, AddCircle24Regular, Eye24Regular, Person24Filled } from '@v2icons/fluent';
import { getDepartmentList, getDepartmentById, deleteDepartment, addDept, editDept } from '@/api/dept.js';
import { getAreaList } from '@/api/area.js';

export default {
    props: {
        queryForm: Object,
        checkState: String,
        resetCheckState: Function
    },
    components: {
        GridDots,
        ArrowDown,
        Refresh,
        Printer,
        Edit24Regular,
        AddCircle24Regular,
        Delete24Regular,
        Eye24Regular,
        DeptUser,
        Person24Filled,
        Search
    },
    watch: {
        checkState(val) {
            console.log({ val });
            if (val == 'check') {
                this.resetDepartmentList();
                this.getDepartmentList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetDepartmentList();
                this.getDepartmentList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            areaList: [],
            multipleSelection: [],
            departmentList: [],
            departmentState: 'add',
            currentDept: {},
            isSearch: false,
            departmentStates: {
                add: '新增部门',
                check: '查看部门',
                edit: '编辑部门',
                addChild: '添加下级部门'
            },
            showDialog: false,
            department: {
                area: {
                    id: ''
                },
                parentId: '',
                deptName: '',
                status: 1,
                sort: 10,
                grade: ''
            },
            dept: {
                id: '',
                deptName: '',
                sort: '',
                status: '',
                parentId: '',
                grade: ''
            },
            dataRule: {
                deptName: [{ required: true, message: '部门名称不能为空', trigger: 'blur' }],
                grade: [{ required: true, message: '部门等级不能为空', trigger: 'blur' }]
            },
            treeProps: {
                children: 'children',
                label: 'deptName'
            }
        };
    },
    created() {
        this.getDepartmentList();
        // this.getAreaList();
    },
    methods: {
        DeptUser(dept) {
            this.currentDept = dept;
            setTimeout(() => {
                this.$refs.deptUser.init();
            }, 200);
        },
        search() {
            this.isSearch = !this.isSearch;
            this.$emit('send', this.isSearch);
        },
        deptUser(dept) {
            console.log('dept' + dept);
            this.currentDept = dept;
            setTimeout(() => {
                this.$refs.deptUser.init();
            }, 200);
        },

        // getAreaList() {
        //     getAreaList().then((res) => {
        //         if (res.success) {
        //             this.areaList = res.list;
        //         }
        //     });
        // },
        resetDepartmentList() {
            this.departmentList = [];
        },
        resetDialog() {
            this.$refs.department.resetFields();
            this.departmentState = 'add';
            this.showDialog = false;
            this.department = {
                deptName: '',
                parentId: '',
                status: 1,
                sort: 10,
                roleIds: [],
                status: 1,
                grade: ''
            };
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.departmentState == 'add') {
                this.$refs.department.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        addDept({ ...this.department }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDepartmentList();
                                this.resetDialog();
                                this.getDepartmentList();
                            }
                        });
                    }
                });
            } else if (this.departmentState == 'edit') {
                this.$refs.department.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        editDept({ ...this.department }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                            this.resetDepartmentList();
                            this.resetDialog();
                            this.getDepartmentList();
                        });
                    }
                });
            } else if (this.departmentState == 'addChild') {
                this.$refs.department.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        addDept({ ...this.department }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDepartmentList();
                                this.resetDialog();
                                this.getDepartmentList();
                            }
                        });
                    }
                });
            }
        },
        addDepartment() {
            this.showDialog = true;
            this.departmentState = 'add';
        },
        checkDepartment(departmentId) {
            console.log(departmentId);
            this.currentDepartmentId = departmentId;
            this.getDepartmentById(); //详细信息

            this.showDialog = true;
            this.departmentState = 'check'; //控制只读，还是可填
        },
        editDepartment(departmentId) {
            console.log('department', departmentId);
            if (departmentId) {
                this.currentDepartmentId = departmentId;
                this.getDepartmentById();
            } else {
                this.department = { ...this.department, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.departmentState = 'edit';
        },
        addChildDepartment(departmentId) {
            this.department.parentId = departmentId;
            this.showDialog = true;
            this.departmentState = 'addChild';
        },

        deleteDepartment(departmentId) {
            let ids = '';
            if (departmentId) {
                ids = departmentId;
            } else {
                ids = this.multipleSelection.map((department) => department.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteDepartment({ ids }).then((res) => {
                        console.log({ res });
                        if (res.success) {
                            this.$message({
                                message: '删除部门成功',
                                type: 'success',
                                duration: 2000
                            });
                            this.resetDepartmentList();
                            this.getDepartmentList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshDepartmentList() {
            this.resetDepartmentList();
            this.getDepartmentList();
        },
        getDepartmentList(query = {}) {
            this.loading = true;
            getDepartmentList({ ...query }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.departmentList = res.treeData;
                }
            });
        },
        getDepartmentById() {
            getDepartmentById({ id: this.currentDepartmentId }).then((res) => {
                if (res.success) {
                    if (res.mppDept.parentId === '0') {
                        res.mppDept.parentId = '';
                    }
                    this.department = { ...this.department, ...res.mppDept };
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
        },
        sizeChange(size) {
            this.pageSize = size;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;

    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
